import { Component, Input, OnInit } from '@angular/core';

import { LogoService } from '@app/core/logo.service';

@Component({
  selector: 'app-sport-team-logo',
  styleUrls: ['./sport-team-logo.component.css'],
  templateUrl: './sport-team-logo.component.html'
})
export class SportTeamLogoComponent implements OnInit {
  @Input() circleFrame: boolean;
  primaryLogoUrl: string;

  @Input()
  set fleet(value) {
    this.primaryLogoUrl = this.logoService.getPrimaryLogoUrl(value);
  }

  constructor(private logoService: LogoService) {}

  ngOnInit() {}
}
